import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import NotificationList from './layout/List';
import NotificationDetails from './layout/Details';
const Notifications = () => {
    const history = useHistory();
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: "/notifications" },
            React.createElement(NotificationList, { onNotificationClick: (id) => history.push(`/notifications/${id}`), showActions: false, fullScreen: true })),
        React.createElement(Route, { exact: true, path: "/notifications/:id", component: NotificationDetails })));
};
export default observer(Notifications);
